/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class UploadsService {
    public static $inject = ['$q', '$http', 'Api'];

    private documents = {
        last_update: undefined,
        files: []
    };

    public defer;

    constructor (private $q: ng.IQService,
                 private $http: ng.IHttpService,
                 private Api: Restangular.IService) {
    }

    public list(): Restangular.IPromise<any> {
        return this.Api.one('uploads').getList();
    }

    public delete(id: string): Restangular.IPromise<any>{
        return this.Api.one('uploads').one(id).remove()
    }
    /**
     * Service return list of documents from cache or do new request and put result in cache
     * You can set a cache time for this
     * @param fn
     */
    public getListFromCache(fn): any {
        const CACHE_TIME = 30; // in seconds

        // If we have cached files and cache valid (by time) then we return files
        if (this.documents.files.length > 0 &&
            (this.documents.last_update && -this.documents.last_update.diff(moment(), 'seconds') < CACHE_TIME)
        ) {
            (fn || angular.noop)(this.documents.files);
        } else {
            // If cache lifetime expires then we send new request
            if (this.documents.last_update && -this.documents.last_update.diff(moment(), 'seconds') > CACHE_TIME && this.defer) {
                this.defer = false;
            }

            // check if we have a promised, then wait promise resolve and return file
            if (this.defer) {
                this.defer.promise.then(() => {
                    (fn || angular.noop)(this.documents.files);
                })
            } else {
                // set cache time
                this.documents.last_update = moment();
                // create new promise
                this.defer = this.$q.defer();
                // send response
                this.list().then((response) => {

                    this.documents.files.length = 0;

                    response.forEach((file) => {
                        this.documents.files.push(file);
                    });

                    this.documents.last_update = moment();

                    this.defer.resolve();

                    (fn || angular.noop)(this.documents.files);
                })
            }
        }
    }

}


angular.module('beneple.global')
    .service('Uploads', UploadsService);



// WEBPACK FOOTER //
// ./frontend/scripts/upload/services/uploads.service.ts